export default (api, resource) => ({


    getAll: async({token})=>{
        const response = await api.get(`${resource}/cartela/${token}`)

        return{
            data: response.data 
        }
    },

    getAllCartelas: async(token, params) =>{

        const response = await api.get(`${resource}/cartela/get-all`,{
            params,
            headers:{
                Authorization: token
            },
        })

        return {
            data: response.data,
            content: response.data.content,
            totalRecords: response.data.totalRecords,
            totalCartelas: response.data.totalCartelas
        }
    },

})